
import api from '../../api/index.js'

const state = {

}

const getters = {

}

const actions = {
    // 获取消息公告集合
    GetGenericArticleNewsList({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/GenericArticle/GetNewsList',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 获取消息公告详细信息
    GetGenericArticleNewsDetail({commit},payload){
        return new Promise((resolve,reject) => {
            api.get('/GenericArticle/GetNewsDetail',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    // 提交意见反馈
    GenericArticleAddFeedbackVue({commit},payload){
        return new Promise((resolve,reject) => {
            api.post('/GenericArticle/AddFeedbackVue',payload, res => {
                resolve(res.Result)
            }, err => {
                reject(err)
            }) 
        });
    },
    

}

const mutations = {

}

export default {
    state,
    getters,
    actions,
    mutations
}
